import { render, staticRenderFns } from "./RelatieContracten.vue?vue&type=template&id=72ab2d56"
import script from "./RelatieContracten.vue?vue&type=script&lang=js"
export * from "./RelatieContracten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports